<div class="banner">
  <i *ngIf="iconUrl" class="icon" [style.backgroundImage]="'url(' + iconUrl + ')'"></i>
  <div>
    <ng-content></ng-content>
  </div>
</div>
